import {
  Box, Stack, Typography, IconButton, Button,
  Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import {
  Close as CloseIcon, Savings as PrepayIcon,
} from '@mui/icons-material';
import PrepaymentForm from './PrepaymentForm';

// ═══════════════════════════════════════════════════════════════════
//  "Let me pay the rest of the term" — said while looking at the
//  learner's row.
//
//  The same form as the accounts desk, opened where somebody already
//  is. Walking them to another screen and asking them to search for the
//  learner again is how a payment ends up against the wrong child.
// ═══════════════════════════════════════════════════════════════════

export default function PrepaymentDialog({
  open, onClose, studentId, studentName, className, incomeType, onDone,
}) {
  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ p: 0 }}>
        <Stack direction="row" spacing={1.5} alignItems="center"
          sx={{ px: 2.2, py: 1.6, bgcolor: '#f1faf5', borderBottom: '1px solid #cfe7d6' }}>
          <Box sx={{
            width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
            bgcolor: '#22a559', color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <PrepayIcon sx={{ fontSize: 21 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 17, fontWeight: 800, color: '#15803d', lineHeight: 1.25 }}>
              Advance payment
            </Typography>
            <Typography noWrap sx={{ fontSize: 11.5, color: '#64748b' }}>
              {studentName || studentId}{className ? ` · ${className}` : ''}
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        {open && (
          <PrepaymentForm
            studentId={studentId}
            studentName={studentName}
            className={className}
            incomeType={incomeType}
            compact
            onDone={(r) => { onDone?.(r); onClose?.(); }} />
        )}
        <Typography sx={{ fontSize: 10.5, color: '#64748b', mt: 1.4, lineHeight: 1.7 }}>
          Posts to the cash book immediately and issues a receipt — it does not go to a
          teacher for collection. Anything owed is cleared first; the rest is held on
          account and spent day by day, and the teacher sees the student as
          <b> Paid ahead</b> with the row locked.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.2, borderTop: '1px solid #e8eef6' }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
